import { render, staticRenderFns } from "./CollectionEditForm.vue?vue&type=template&id=2e8568c4&"
import script from "./CollectionEditForm.vue?vue&type=script&lang=js&"
export * from "./CollectionEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports